import { useMutation } from "@tanstack/vue-query";

export function useSurveySubmission() {
  return useMutation({
    async mutationFn(params: {
      subscriberId: string;
      responses: Record<string, string | number | number[]>;
    }) {
      const surveyUrl = `${window.location.pathname.replace(
        /\/$/,
        ""
      )}/survey-responses`;
      const response = await fetch(surveyUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          subscriber_id: params.subscriberId,
          responses: params.responses,
        }),
      });
      if (!response.ok) {
        console.error("Failed to submit survey responses", response.status);
      }
    },
  });
}
